import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export default function OurGoal() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="our-goal-section" style={{ padding: "100px 20px", background: "#f9fafb" ,paddingBottom:"130px"}}>
      <div className="goal-container" style={{ maxWidth: "1100px", margin: "0 auto" }}>
        {/* Heading */}
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h3 className="goal-subtitle" data-aos="fade-up" style={{ color: "#1aa3a3", fontWeight: "600", letterSpacing: "2px" }}>
            OUR GOAL
          </h3>
          <h2 className="goal-title" data-aos="fade-up" data-aos-delay="150" style={{ fontSize: "2.2rem", fontWeight: "700", color: "#1f2937" }}>
            A Message From Our CEO
          </h2>
        </div>

        {/* Content */}
        <div 
          className="goal-content" 
          style={{ display: "flex", alignItems: "center", gap: "40px", flexWrap: "wrap" }}
        >
          {/* CEO Image */}
          <div 
            className="goal-img" 
            data-aos="fade-right" 
            style={{ flex: "1 1 300px", textAlign: "center" }}
          >
            <img 
              src="/Gallerypics/Owner1.1.png" 
              alt="CEO" 
              style={{ width: "280px", height: "350px", objectFit: "cover", borderRadius: "12px", boxShadow: "0 10px 25px rgba(0,0,0,0.15)" }} 
            />
            <h4 style={{ marginTop: "15px", fontSize: "18px", fontWeight: "600", color: "#1f2937" }}>
              Javed Akhter
            </h4>
            <p style={{ fontSize: "14px", color: "#6b7280" }}>CEO & Founder</p>
          </div>

          {/* CEO Message */}
          <div 
            className="goal-text" 
            data-aos="fade-left" 
            style={{ flex: "2 1 500px" }}
          >
            <p style={{ fontSize: "16px", lineHeight: "1.7", color: "#374151", marginBottom: "20px" }}>
              At <strong>JAS Contractors</strong>, our goal is not just to paint buildings but to bring life, 
              color, and durability to every project we undertake. We believe that quality, honesty, 
              and customer satisfaction are the foundations of our success.
            </p>
            <p style={{ fontSize: "16px", lineHeight: "1.7", color: "#374151", marginBottom: "20px" }}>
              As the CEO, I personally ensure that every project reflects our commitment to excellence 
              and professionalism. My team and I are dedicated to delivering innovative solutions that 
              not only meet but exceed our clients’ expectations.
            </p>
            <p style={{ fontSize: "16px", lineHeight: "1.7", color: "#374151", fontStyle: "italic" }}>
              "We don’t just build walls; we build trust, reliability, and long-lasting partnerships."
            </p>
            <div style={{ marginTop: "30px" }}>
              <h4 style={{ fontFamily: "cursive", fontSize: "20px", color: "#1aa3a3" }}>Javed Akhter</h4>
              <p style={{ fontSize: "14px", color: "#6b7280" }}>Chief Executive Officer</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
